import React from 'react';

export default function FwLockIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-lock' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
